module.exports = __webpack_public_path__ + "static/media/bike3c.7f45a578.jpg";